import { CUSTOM_QUESTION_TYPES_ID } from "../../../../CustomQuestions/constants/CustomQuestions.constants";

export const questionsPlaceholderMap = {
  [CUSTOM_QUESTION_TYPES_ID.SHORT_TEXT]: "Enter Text",
  [CUSTOM_QUESTION_TYPES_ID.NUMBER]: "Enter Number",
  [CUSTOM_QUESTION_TYPES_ID.URL]: "Enter Url",
};

export const CUSTOM_QUESTION_MULTI_QUESTIONS_KEY = "multi_questions";
export const CUSTOM_QUESTION_ANS_KEY = "ans";
